import React from "react";
import { buildShiftListStatusDisplay } from "../../utils/shiftListStatusDisplay";

export default function ClientScheduleCheckInBadge({ shift, className = "" }) {
  const statusDisplay = buildShiftListStatusDisplay({
    checkInState: shift.checkInState,
    checkin_date: shift.checkin_date,
    checkout_date: shift.checkout_date,
    checkin_unpaid_break_minutes: shift.checkin_unpaid_break_minutes,
    signoff_state: shift.signoff_state,
    actual_state: shift.actual_state,
    start_date: shift.start_date,
    end_date: shift.end_date,
    unpaid_break: shift.unpaid_break,
    checkin_signoff_date: shift.checkin_signoff_date,
  });

  if (!statusDisplay.chipLabel) return null;

  return (
    <div className={`flex flex-col items-end gap-0.5 flex-shrink-0 ${className}`}>
      {statusDisplay.showCheckinInfo && statusDisplay.line1 ? (
        <div className="text-[10px] text-gray-600 text-right leading-tight">
          <div>{statusDisplay.line1}</div>
          {statusDisplay.line2 ? <div>{statusDisplay.line2}</div> : null}
        </div>
      ) : null}
      <span
        className="inline-flex items-center rounded px-2 py-0.5 text-[10px] font-medium text-white leading-tight whitespace-nowrap"
        style={{ backgroundColor: statusDisplay.chipColor }}
      >
        {statusDisplay.chipLabel}
      </span>
    </div>
  );
}
